import { AxiosInstance } from 'axios';
import { CreateActionPlanDto } from 'api/dto/new/ActionPlan/CreateActionPlan.dto';
import {
  ActionPlanExistsQuery,
  ActionPlanExistsResponse,
} from 'api/dto/new/ActionPlan/ActionPlanExists.dto';
import {
  CreateSuggestedActionsJobDto,
  CreateSuggestedActionsJobResponse,
  RegenerateSuggestedActionsJobDto,
} from 'api/dto/new/ActionPlan/SuggestedActionsJob.dto';

type CreateActionPlanResponse = {
  id: string;
};

export class ActServiceApi {
  constructor(private readonly client: AxiosInstance) {}

  createActionPlan(dto: CreateActionPlanDto): Promise<CreateActionPlanResponse> {
    return this.client
      .post<CreateActionPlanResponse>('/api/v1/action-plans', dto)
      .then((response) => response.data);
  }

  checkActionPlanExists(query: ActionPlanExistsQuery): Promise<ActionPlanExistsResponse> {
    return this.client
      .get<ActionPlanExistsResponse>('/api/v1/action-plans/exists', { params: query })
      .then((response) => response.data);
  }

  createSuggestedActionsJob(
    dto: CreateSuggestedActionsJobDto
  ): Promise<CreateSuggestedActionsJobResponse> {
    return this.client
      .post<CreateSuggestedActionsJobResponse>('/api/v1/suggested-actions/jobs', dto)
      .then((response) => response.data);
  }

  regenerateSuggestedActionsJob(
    dto: RegenerateSuggestedActionsJobDto
  ): Promise<CreateSuggestedActionsJobResponse> {
    return this.client
      .post<CreateSuggestedActionsJobResponse>('/api/v1/suggested-actions/jobs/regenerate', dto)
      .then((response) => response.data);
  }

  // Returns `unknown` deliberately: the "job still processing" response shape isn't confirmed,
  // so narrowing "is this actually done?" belongs to the poller, not this API layer.
  getSuggestedActionsJob(jobId: string): Promise<unknown> {
    return this.client
      .get(`/api/v1/suggested-actions/jobs/${jobId}`)
      .then((response) => response.data);
  }
}
